import styled from "styled-components";
import { desktop, mobile } from "../globalAssets/fontsize";
import { BsArrowLeft } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { device } from "../globalAssets/breakpoints";
export const Back = () => {
  const history = useHistory();
  return (
    <BackContainer onClick={() => history.goBack()}>
      <div>
        <BsArrowLeft />
      </div>
      <h5>back</h5>
    </BackContainer>
  );
};

export const FilterButton = styled.div`
  & > div {
    display: none;
  }
  & > button {
    display: block;
    background: #3b72bb;
    margin-top: 15px;
    color: white;
    font-weight: 500;
    padding: 5px 0;
    font-size: 18px;
    outline: none;
    border: none;
    width: 50vw;
    margin-right: "15px";
    border-radius: 5px;
    margin-left: "-15px" !important;
  }
  @media ${device.laptop} {
    & > div {
      display: block;
    }
    & > button {
      display: none;
    }
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.subtleGrey};
  & > div {
    display: flex;
    align-items: center;
    margin: 0;
    color: ${(props) => props.theme.grey};
    font-size: ${mobile.medium};
  }
  & > h3 {
    margin: 0;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 300;
    color: ${(props) => props.theme.grey};
  }
  @media ${device.laptop} {
    & > div {
      font-size: ${desktop.medium};
    }
    & > h3 {
      font-size: ${desktop.small};
    }
  }
`;
export const BackContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  box-shadow: ${(props) => props.theme.subtleShadow};
  cursor: pointer;
  background: ${(props) => props.theme.foreground};
  & > div {
    font-size: 20px;
    color: ${(props) => props.theme.color};
    margin: 0;
    display: flex;
    align-items: center;
  }
  & > h5 {
    margin: 0;
    color: ${(props) => props.theme.color};
    font-size: 13px;
  }
  @media ${device.laptop} {
    & > div {
      font-size: ${desktop.large};
    }
    & > h5 {
      font-size: ${desktop.small};
    }
  }
`;

export const BigContentContainer = styled.div`
  width: 100%;
  /* position: sticky; */
  /* height: 80vh; */
  /* overflow-y: auto; */
  /* top: 10vh; */
  background: none;
  & > h1,
  div {
    color: ${(props) => props.theme.color};
  }
  & > div,
  h3 {
    color: ${(props) => props.theme.grey};
  }
`;
export const FilterContainer = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  width: 100%;
  margin-bottom: 10px;
  height: 60vh;
  & > div {
    padding: 5px;
    & > h3 {
      color: ${(props) => props.theme.color};
      font-weight: 600;
      margin: 0;
      font-size: 14px;
      padding: 5px;
      background: ${(props) => props.theme.background};
      box-shadow: ${(props) => props.theme.subtleShadow};
      width: 100%;
    }
  }
  @media ${device.laptop} {
    top: 15vh;
    position: sticky;
    /* overflow-y: auto; */
    & > div {
      padding: 0.5vw;
      & > h3 {
        font-size: ${desktop.small};

        padding: 0.5vw;
      }
    }
  }
`;

export const SmallMapContainer = styled.div`
  width: 100%;
  height: 50vh;
`;
